// extracted by css-extract-rspack-plugin
export default {"loginButton":"Login_loginButton__sFZJn"};